/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
} from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface SourcedCarrierRatesResponse {
  filterOptions?: { [key: string]: any }
  nextPage?: boolean
  shipmentPermissions?: {
    key?: string
    params?: { [key: string]: any }
    permissions?: { [key: string]: any }
  }[]
  sourcedCarrierRates?: SourcedCarrierRateObject[]
  userPermissions?: { [key: string]: any }
}

export interface SourcedCarrierRateObject {
  id?: number
  minCapacity?: number | null
  maxCapacity?: number | null
  canDoWeekends?: boolean | null
  confirmed?: boolean | null
  createdAt?: string
  updatedAt?: string | null
  createdBy?: {
    id?: number
    parentUserId?: number
    fullName?: string
  }
  updatedBy?: {
    id?: number
    parentUserId?: number
    fullName?: string
  } | null
  carrierApplication?: {
    id?: number
    name?: string
  }
  rate?: {
    amount?: string
    rateTypeKey?: string
  } | null
  pickupCity?: string | null
  pickupStateCode?: string | null
  pickupDatMarket?: string | null
  deliveryCity?: string | null
  deliveryStateCode?: string | null
  deliveryDatMarket?: string | null
  transfixShipperLaneId?: number | null
  dropType?: string
  equipment?: Equipment
  rateSource?: 'Bid' | 'Award' | 'FMS' | '' | null
}

/**
 * Equipment Information
 */
export interface Equipment {
  id?: number
  key?: string
  name?: string
  parentId?: number
  createdAt?: string
  updatedAt?: string
  position?: number
}

export interface GetSourcedCarrierRatesPathParams {
  /**
   * ID of the Shipper Rate
   */
  shipperRateId: number
}

export type GetSourcedCarrierRatesProps = Omit<
  GetProps<SourcedCarrierRatesResponse, unknown, void, GetSourcedCarrierRatesPathParams>,
  'path'
> &
  GetSourcedCarrierRatesPathParams

/**
 * List sourced carrier rates associated with a shipper rate
 */
export const GetSourcedCarrierRates = ({
  shipperRateId,
  ...props
}: GetSourcedCarrierRatesProps) => (
  <Get<SourcedCarrierRatesResponse, unknown, void, GetSourcedCarrierRatesPathParams>
    path={`/v9/shipper_rates/${shipperRateId}/sourced_carrier_rates`}
    {...props}
  />
)

export type UseGetSourcedCarrierRatesProps = Omit<
  UseGetProps<SourcedCarrierRatesResponse, unknown, void, GetSourcedCarrierRatesPathParams>,
  'path'
> &
  GetSourcedCarrierRatesPathParams

/**
 * List sourced carrier rates associated with a shipper rate
 */
export const useGetSourcedCarrierRates = ({
  shipperRateId,
  ...props
}: UseGetSourcedCarrierRatesProps) =>
  useGet<SourcedCarrierRatesResponse, unknown, void, GetSourcedCarrierRatesPathParams>(
    (paramsInPath: GetSourcedCarrierRatesPathParams) =>
      `/v9/shipper_rates/${paramsInPath.shipperRateId}/sourced_carrier_rates`,
    { pathParams: { shipperRateId }, ...props }
  )

export interface CreateSourcedCarrierRatesPathParams {
  /**
   * ID of the Shipper Rate
   */
  shipperRateId: number
}

export interface CreateSourcedCarrierRatesRequestBody {
  sourcedCarrierRates?: {
    carrierApplicationId?: number
    minCapacity?: number
    maxCapacity?: number
    canDoWeekends?: boolean
    confirmed?: boolean
    rateAttributes?: {
      amount?: number
      rateTypeKey?: string
    }
  }[]
}

export type CreateSourcedCarrierRatesProps = Omit<
  MutateProps<
    void,
    void,
    void,
    CreateSourcedCarrierRatesRequestBody,
    CreateSourcedCarrierRatesPathParams
  >,
  'path' | 'verb'
> &
  CreateSourcedCarrierRatesPathParams

/**
 * Create sourced carrier rates on shipper rate
 */
export const CreateSourcedCarrierRates = ({
  shipperRateId,
  ...props
}: CreateSourcedCarrierRatesProps) => (
  <Mutate<
    void,
    void,
    void,
    CreateSourcedCarrierRatesRequestBody,
    CreateSourcedCarrierRatesPathParams
  >
    verb='POST'
    path={`/v9/shipper_rates/${shipperRateId}/sourced_carrier_rates`}
    {...props}
  />
)

export type UseCreateSourcedCarrierRatesProps = Omit<
  UseMutateProps<
    void,
    void,
    void,
    CreateSourcedCarrierRatesRequestBody,
    CreateSourcedCarrierRatesPathParams
  >,
  'path' | 'verb'
> &
  CreateSourcedCarrierRatesPathParams

/**
 * Create sourced carrier rates on shipper rate
 */
export const useCreateSourcedCarrierRates = ({
  shipperRateId,
  ...props
}: UseCreateSourcedCarrierRatesProps) =>
  useMutate<
    void,
    void,
    void,
    CreateSourcedCarrierRatesRequestBody,
    CreateSourcedCarrierRatesPathParams
  >(
    'POST',
    (paramsInPath: CreateSourcedCarrierRatesPathParams) =>
      `/v9/shipper_rates/${paramsInPath.shipperRateId}/sourced_carrier_rates`,
    { pathParams: { shipperRateId }, ...props }
  )
